"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMgmtApiBulkIteratorService = void 0;
var debug_1 = require("debug");
var debug = debug_1.default('ContentMgmtAPIBulkIterator');
/**
 * Exposes an iterator which allows iterating over all documents of a partition
 * @class ContentMgmtApiBulkIteratorService
 */
var ContentMgmtApiBulkIteratorService = /** @class */ (function () {
    /**
     * A new bulk iterator
     * @param {} client - Instance of Content Management API client
     * @param {string} typeRRN - The type to iterate over (e.g. 'rrn:content:stories', 'rrn:content:event-profiles', 'rrn:featuring-records', etc.)
     * @param options. An options object with additional configuration e.g. 'spaces', 'includeUnpublished' 'includeDraft'
     */
    function ContentMgmtApiBulkIteratorService(client, typeRRN, options) {
        if (options === void 0) { options = {}; }
        this.client = client;
        var fetchBatchSize = options && options.maxBatchSize ? options.maxBatchSize : 75;
        var spaces = options.spaces;
        var includeDraft = options && options.includeDraft ? options.includeDraft : false;
        var includeUnpublished = options && options.includeUnpublished ? options.includeUnpublished : false;
        var collectionEndpointPathForType = "v4/types/" + typeRRN + "/resources";
        this.nextPageLink = "/" + collectionEndpointPathForType + "?page[limit]=" + fetchBatchSize + "&includeDraft=" + includeDraft + "&includeUnpublished=" + includeUnpublished; // tslint:disable-line max-line-length
        this.nextPageLink = spaces ? this.nextPageLink + "&filter[meta.spaces]=" + spaces.join(',') : this.nextPageLink;
        this.pageResources = [];
        this.currentIteratorOffsetInPage = 0;
        this.requestHeaders = options === null || options === void 0 ? void 0 : options.requestHeaders;
    }
    /**
     * Get next resource from API
     * @returns {Promise<ContentResource | null>}
     */
    ContentMgmtApiBulkIteratorService.prototype.next = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var page;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.currentIteratorOffsetInPage >= this.pageResources.length && this.nextPageLink)) return [3 /*break*/, 2];
                        // load next page
                        debug("Fetch next batch from content mgmt API " + this.nextPageLink);
                        return [4 /*yield*/, this.client.getResourcesByNextLink(this.nextPageLink, { requestHeaders: this.requestHeaders })];
                    case 1:
                        page = _c.sent();
                        this.pageResources = (_a = page === null || page === void 0 ? void 0 : page.data) !== null && _a !== void 0 ? _a : [];
                        this.nextPageLink = (_b = page.links) === null || _b === void 0 ? void 0 : _b.next;
                        this.currentIteratorOffsetInPage = 0;
                        _c.label = 2;
                    case 2:
                        if (this.currentIteratorOffsetInPage <= this.pageResources.length) {
                            this.currentIteratorOffsetInPage += 1;
                            return [2 /*return*/, this.pageResources[this.currentIteratorOffsetInPage - 1]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * True if another resource is available to fetch
     * @returns {boolean}
     */
    ContentMgmtApiBulkIteratorService.prototype.hasNext = function () {
        return !!(this.currentIteratorOffsetInPage < this.pageResources.length || this.nextPageLink);
    };
    /**
     * Invoke a callback on each resource. Returns a promise which is resolved if all resources have been processed.
     * @param {IteratorCallbackFun} promise
     * @returns {Promise<BatchResult>}
     */
    ContentMgmtApiBulkIteratorService.prototype.each = function (promise) {
        return __awaiter(this, void 0, void 0, function () {
            var nResources, resource;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nResources = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.next()];
                    case 2:
                        resource = _a.sent();
                        if (!resource) {
                            throw new Error('Failed to load asset. Exiting.');
                        }
                        return [4 /*yield*/, promise(resource)];
                    case 3:
                        _a.sent();
                        nResources += 1;
                        _a.label = 4;
                    case 4:
                        if (this.hasNext()) return [3 /*break*/, 1];
                        _a.label = 5;
                    case 5: return [2 /*return*/, {
                            status: 'SUCCESS',
                            nResourcesProcessed: nResources,
                        }];
                }
            });
        });
    };
    /**
     * Fetches all resources of a partition.
     * @returns {Promise<ContentResourceApiCollectionResponse>}
     */
    ContentMgmtApiBulkIteratorService.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resources, resource;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resources = [];
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.next()];
                    case 2:
                        resource = _a.sent();
                        if (resource) {
                            resources.push(resource);
                        }
                        _a.label = 3;
                    case 3:
                        if (this.hasNext()) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4: return [2 /*return*/, {
                            data: resources,
                        }];
                }
            });
        });
    };
    return ContentMgmtApiBulkIteratorService;
}());
exports.ContentMgmtApiBulkIteratorService = ContentMgmtApiBulkIteratorService;
//# sourceMappingURL=content-mgmt-api-bulk-iterator.service.js.map